export default {
  // we store vehicles in an array in the store, they can be accessed through getters in different formats, such as a map when required
  vehicles: [],

  // vehicle status is set in the updatePresence mutation. we use this to keep track of which vehicles are online
  // we use a holding to update the state every 10 seconds so the UI is not having to deal with state changing multiple times a second as a result of websockets
  // this update function can be found in the mutations and is triggered in the WebSocket.vue component
  vehicleStatus: {}, 

  // when a go user is on the site, we use the GO api to fetch driver names and store these as key value pairs (veh_id => driver_name)
  vehicleDrivers: {},
  // data for historical drivers, this is stored by vehicle, by unix timestamp
  historicalDrivers: {},
  // device pres map, key id device id, val is pres object :)
  // we use a holding to update the state every 10 seconds so the UI is not having to deal with state changing multiple times a second as a result of websockets
  // this update function can be found in the mutations and is triggered in the WebSocket.vue component
  devicesMap: {},

  // map of IDs spotlighted by the user
  spotlight: {},

  mapData: [],

  devicesByVehicle: {},
  // reset counter
  spotlightResetCounter: 0
}